import SubPageLayout from '../helpers/SubPageLayout';


const CatalogView = () => {
  

  return (
    <SubPageLayout title="Products">
      
    </SubPageLayout>
  );
};

export default CatalogView;